import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, Optional, inject } from '@angular/core';
import { Request } from 'express';
import { baseUrl, isAbsoluteUrl } from 'src/app/common/utils/helpers';
import { REQUEST } from 'src/express.tokens';

const handledRequest = (req: HttpRequest<any>, isServer: boolean) => {
  if (!isAbsoluteUrl(req.url) && isServer) {
    const pathSeparator = !req.url.startsWith('/') ? '/' : '';
    const url = baseUrl + pathSeparator + req.url;
    const serverRequest = req.clone({ url });
    // console.log('internal url: ', url);
    return serverRequest;
  }
  // console.log('external url: ', req.url);
  return req;
};

@Injectable({ providedIn: 'root' })
export class RequestInterceptor {
  constructor(@Optional() @Inject(REQUEST) private httpRequest: Request) {}
  intercept(req: HttpRequest<any>, next: HttpHandlerFn) {
    // Stop using the cache if there is a mutating call.
    if (this.httpRequest && req.url.endsWith('/graphql')) {
      if (this.httpRequest.headers?.cookie) {
        const request = req.clone({
          setHeaders: {
            ['Cookie']: this.httpRequest.headers?.cookie,
          },
          withCredentials: true,
        });
        return next(request);
      } else {
        return next(req);
      }
    }
    return next(req);
  }
}

export const requestInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) =>
  inject(RequestInterceptor).intercept(req, next);
